export default {
  'pages.layouts.userLayout.title':
    'Ant Design adalah spesifikasi desain Web yang paling berpengaruh di Kabupaten Xihu',
  'pages.login.accountLogin.tab': 'Login dengan akun',
  'pages.login.accountLogin.errorMessage':
    'Nama pengguna dan kata sandi salah(admin/ant.design)',
  'pages.login.failure': 'Log masuk gagal, silakan coba lagi!',
  'pages.login.success': 'Login berhasil!',
  'pages.login.username.placeholder': 'nama pengguna: admin atau user',
  'pages.login.username.required': 'Nama pengguna harus diisi!',
  'pages.login.password.placeholder': 'kata sandi: ant.design',
  'pages.login.password.required': 'Kata sandi harus diisi!',
  'pages.login.phoneLogin.tab': 'Login dengan ponsel',
  'pages.login.phoneLogin.errorMessage': 'Kesalahan kode verifikasi',
  'pages.login.phoneNumber.placeholder': 'masukkan nomor telepon',
  'pages.login.phoneNumber.required': 'Nomor ponsel harus diisi!',
  'pages.login.phoneNumber.invalid': 'Nomor ponsel tidak valid!',
  'pages.login.captcha.placeholder': 'kode verifikasi',
  'pages.login.captcha.required': 'Kode verifikasi diperlukan!',
  'pages.login.phoneLogin.getVerificationCode': 'Dapatkan kode',
  'pages.getCaptchaSecondText': 'detik tersisa',
  'pages.login.rememberMe': 'Ingat saya',
  'pages.login.forgotPassword': 'Lupa Kata Sandi?',
  'pages.login.submit': 'Masuk',
  'pages.login.loginWith': 'Masuk dengan :',
  'pages.login.welcome': 'Selamat datang di Platform Pemrosesan Video Cerdas',
  'pages.login.registerAccount': 'Daftar Akun',
  'pages.welcome.link': 'Selamat datang',
  'pages.welcome.alertMessage':
    'Komponen heavy-duty yang lebih cepat dan lebih kuat telah dirilis.',
  'pages.404.subTitle': 'Maaf, halaman yang Anda kunjungi tidak ada. ',
  'pages.404.buttonText': 'Kembali ke halaman utama',
  'pages.admin.subPage.title': 'Halaman ini hanya dapat dilihat oleh admin',
  'pages.admin.subPage.alertMessage':
    'umi ui telah dirilis, silahkan gunakan npm run ui untuk memulai pengalaman.',
  'pages.searchTable.createForm.newRule': 'Aturan baru',
  'pages.searchTable.updateForm.ruleConfig': 'Konfigurasi aturan',
  'pages.searchTable.updateForm.basicConfig': 'Informasi dasar',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nama aturan',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Harap masukkan nama aturan!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Deskripsi aturan',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Harap masukkan setidaknya lima karakter',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Harap masukkan deskripsi aturan setidaknya lima karakter!',
  'pages.searchTable.updateForm.ruleProps.title': 'Properti aturan',
  'pages.searchTable.updateForm.object': 'Objek pemantauan',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Template aturan',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Jenis aturan',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Periode penjadwalan',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Waktu mulai',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Pilih waktu mulai!',
  'pages.searchTable.titleDesc': 'deskripsi',
  'pages.searchTable.ruleName': 'Nama aturan wajib diisi',
  'pages.searchTable.titleCallNo': 'Jumlah panggilan',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'menyala',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Waktu terjadwal',
  'pages.searchTable.exception': 'Harap masukkan alasan pengecualian!',
  'pages.searchTable.titleOption': 'Pengoperasian',
  'pages.searchTable.config': 'Konfigurasi',
  'pages.searchTable.subscribeAlert': 'Berlangganan notifikasi',
  'pages.searchTable.title': 'Formulir pertanyaan',
  'pages.searchTable.new': 'Baru',
  'pages.searchTable.chosen': 'Terpilih',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Jumlah total panggilan layanan',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'Penghapusan batch',
  'pages.searchTable.batchApproval': 'Persetujuan batch',
  'pages.employee.management': 'Manajemen Karyawan',
  'pages.employee.new': 'Tambah Karyawan',
  'pages.employee.detail': 'Detail',
  'pages.employee.edit': 'Ubah',
  'pages.employee.delete': 'Hapus',
  'pages.employee.deleteConfirm': 'Apakah Anda yakin ingin menghapus data ini?',
  'pages.employee.okText': 'OK',
  'pages.employee.cancelText': 'Batal',
  'pages.employee.deleteSuccess': 'Berhasil dihapus',
  'pages.employee.deleteFailed': 'Gagal menghapus',
  'pages.employee.fetchDetailFailed': 'Gagal mendapatkan detail',
  'pages.employee.createTitle': 'Buat Karyawan',
  'pages.employee.editTitle': 'Ubah Karyawan',
  'pages.employee.detailTitle': 'Detail Karyawan',
  'pages.employee.updatedSuccessfully': 'Berhasil diperbarui',
  'pages.employee.createdSuccessfully': 'Berhasil dibuat',
  'pages.employee.updateFailed': 'Gagal memperbarui, silakan coba lagi',
  'pages.employee.createFailed': 'Gagal membuat, silakan coba lagi',
  'pages.employee.employeeNumber': 'Nomor Karyawan',
  'pages.employee.name': 'Nama',
  'pages.employee.organization': 'Organisasi',
  'pages.employee.department': 'Departemen',
  'pages.employee.position': 'Jabatan',
  'pages.employee.role': 'Peran',
  'pages.employee.status': 'Status',
  'pages.employee.active': 'Aktif',
  'pages.employee.inactive': 'Nonaktif',
  'pages.employee.remark': 'Catatan',
  'pages.employee.namePlaceholder': 'Silakan masukkan nama!',
  'pages.employee.employeeId': 'ID Karyawan',
  'pages.employee.employeeIdPlaceholder': 'Silakan masukkan ID karyawan',
  'pages.employee.selectDepartment': 'Silakan pilih departemen',
  'pages.employee.selectPosition': 'Silakan pilih jabatan',
  'pages.employee.operation': 'Operasi',
  'pages.employee.deleteConfirmContent':
    'Apakah Anda yakin ingin menghapus karyawan ini?',
};
